import "./HeroHomeStyles.css";
// import HPMacModel from "./HPMacModel";


function HeroHome(props){
    return(
        <>
            <section className={props.cName}>        
                <div className="herohome-text">
                    <h1>{props.title}</h1>
                    <p>{props.text}</p>
                    <p>{props.goldText}</p>
                    <a href={props.url} className={props.btnClass}>{props.btnText}</a>
                </div>
                {/**            
                <div className="herohome-spline">
                     <iframe title="Spline thing" src='https://my.spline.design/macrophage30-dc6c16a565bb07bc92753c389ac2860d/' frameborder='0' width='100%' height='100%'></iframe>
                </div>    
 */}
    
            </section>
        </>
    )
}

export default HeroHome;
